import React, { useState } from "react";
import { appText } from "../../../../texts";
import { FaLayerGroup } from "react-icons/fa6";

const { layerSelectorText } = appText;

const DropdownLayerSelector = ({ selectedLayer, onLayerChange }) => {
    const [isClicked, setIsClicked] = useState(false);

    const handleClick = () => {
        setIsClicked(true);
        setTimeout(() => {
            setIsClicked(false);
        }, 2000);
    };
    const handleChange = (event) => {
        onLayerChange(event);
        setIsClicked(false);
    };

    return (
        <div
            className={`w-fit lg:w-[11rem]  text-white rounded-t-0 rounded-l-[2em] rounded-r-[2em] items-center py-1 justify-between px-1 rounded-b-0 flex relative clear-both 
            ${isClicked ? "bg-[#f39c12]" : "bg-[#00000080]"}`}
            onClick={handleClick}
        >
            <select
                value={selectedLayer}
                onChange={handleChange}
                className="bg-transparent text-[16px] px-2 font-[myFont] cursor-pointer outline-none hidden lg:flex "
            >
                <option className="bg-[#00000080]"  value="osm1">انتخاب لایه</option>
                <option className="bg-[#00000080]" value="osm">{layerSelectorText.whiteText}</option>
                <option className="bg-[#00000080]" value="satellite">{layerSelectorText.satelliteText}</option>
                <option className="bg-[#00000080]" value="dark">{layerSelectorText.blackText}</option>
            </select>
            <div className={`p-2  ${isClicked ? "bg-[#f39c12]" : "bg-white"} w-fit rounded-full text-black`}>
                <FaLayerGroup color={isClicked ? "#ffffff" : "#0272b2"} size={20} />
            </div>
        </div>
    );
};

export default DropdownLayerSelector;
